import React from "react";
import { LogOutIcon } from "lucide-react";

const MobileHeader = ({ onSearch, searchQuery, onLogout }) => {
  return (
    <div className="mobile-header-gradient text-white p-3 sticky-top shadow d-flex justify-content-between align-items-center">
      <div className="d-flex align-items-center bg-white rounded-pill px-3 flex-grow-1">
        <i className="mdi mdi-magnify text-muted mr-2"></i>
        <input
          type="text"
          className="form-control border-0 shadow-none px-0"
          placeholder="Search Item..."
          value={searchQuery}
          onChange={(e) => onSearch(e.target.value)}
        />
      </div>
      <div className="d-flex align-items-center ml-2">
        <button className="btn text-white" onClick={onLogout}>
          <LogOutIcon />
        </button>
      </div>
    </div>
  );
};

export default MobileHeader;

